/* ============================================================================
   GENDER — one Women / Men state for the page. Each gendered section has its
   own Toggle (169:17949) as Figma draws it, and every toggle drives the same
   state: pick Men in Our Catalog and the Core Line and Define Your Uniform
   follow, the way the site's own Women / Men nav does. The section the
   shopper touched animates; the others are already swapped when they
   scroll to them.
   ========================================================================== */

const KEY = 'figs-lab:ncl-gender';
const subs = new Set();
let current = 'women';
try {
  const saved = sessionStorage.getItem(KEY);
  if (saved === 'men' || saved === 'women') current = saved;
} catch (e) { /* storage blocked: default to Women */ }

export const gender = () => current;
export function onGender(fn) { subs.add(fn); return () => subs.delete(fn); }

export function setGender(g, source = null) {
  if (g === current || (g !== 'women' && g !== 'men')) return;
  current = g;
  try { sessionStorage.setItem(KEY, g); } catch (e) { /* ignore */ }
  syncToggles();
  subs.forEach((fn) => fn(g, source));
}

function syncToggles() {
  document.querySelectorAll('[data-gender-toggle] [data-gender]').forEach((b) => {
    b.setAttribute('aria-pressed', String(b.dataset.gender === current));
  });
}

export function mountToggles(root = document) {
  root.querySelectorAll('[data-gender-toggle]').forEach((t) => {
    t.innerHTML = ['women', 'men'].map((g) => `
      <button class="ncl-gtoggle__btn" type="button" data-gender="${g}" aria-pressed="${g === current}">${g}</button>`).join('');
    t.addEventListener('click', (e) => {
      const b = e.target.closest('[data-gender]');
      if (b) setGender(b.dataset.gender, t.closest('section'));
    });
  });
}
